import type {
  Course,
  BookmarkEntityResponseCollection,
  BookmarkPage,
  KnowledgeBase,
} from '@edwin-group/people-graphql/generated/graphql';
import { GENERATED } from '@edwin-group/people-graphql';
import { fetchBookmarkPage, fetchUserBookmarks } from '@/services/bookmark/bookmark.service';
import { create } from 'zustand';

const SIZE = 3;
interface BookmarkStoreProps {
  knowledgebasesBookmarks: BookmarkEntityResponseCollection | null;
  knowledgebases: KnowledgeBase[];
  knowledgebasesSize: number;
  showKnowledgeBasesMoreButton: boolean;

  coursesBookmarks: BookmarkEntityResponseCollection | null;
  courses: Course[];
  coursesSize: number;
  showCoursesMoreButton: boolean;

  page: BookmarkPage | null;

  fetchBookmarks: (type: GENERATED.Enum_Bookmark_Category, size: number) => Promise<void>;
  removeFromBookmark: (type: GENERATED.Enum_Bookmark_Category) => Promise<void>;
  onInit: () => Promise<void>;
  onInitPage: () => Promise<void>;

  handleMore: (type: GENERATED.Enum_Bookmark_Category) => void;
  fetchAndSetPodcasts: () => Promise<void>;
  fetchAndSetKnowledgeBases: () => Promise<void>;
  fetchAndSetCourses: () => Promise<void>;
}

export const useBookmarkStore = create<BookmarkStoreProps>()((set, get) => ({
  podcasts: [],
  podcastsBookmarks: null,
  podcastsSize: SIZE,
  showPodcastsMoreButton: false,

  knowledgebases: [],
  knowledgebasesBookmarks: null,
  knowledgebasesSize: SIZE,
  showKnowledgeBasesMoreButton: false,

  courses: [],
  coursesBookmarks: null,
  coursesSize: SIZE,
  showCoursesMoreButton: false,

  page: null,

  onInit: async () => {
    const { knowledgebasesSize, fetchBookmarks, onInitPage } = get();
    await Promise.all([
      fetchBookmarks(GENERATED.Enum_Bookmark_Category.KnowledgeBase, knowledgebasesSize),
      //   fetchBookmarks(GENERATED.Enum_Bookmark_Category.Learn, coursesSize),
      onInitPage(),
    ]);
  },
  onInitPage: async () => {
    const pageResponse = await fetchBookmarkPage();
    set({ page: pageResponse.data?.bookmarkPage as BookmarkPage });
  },
  fetchBookmarks: async (type: GENERATED.Enum_Bookmark_Category, size: number) => {
    const bookmarksResponse = await fetchUserBookmarks(type, size);

    if (type === GENERATED.Enum_Bookmark_Category.KnowledgeBase) {
      set({
        knowledgebasesBookmarks: bookmarksResponse.data?.bookmarks as BookmarkEntityResponseCollection,
        knowledgebasesSize: size,
      });
      get().fetchAndSetKnowledgeBases();
    }
  },
  removeFromBookmark: async (type: GENERATED.Enum_Bookmark_Category) => {
    await get().fetchBookmarks(type, SIZE);
  },
  fetchAndSetPodcasts: async () => {},
  fetchAndSetKnowledgeBases: async () => {
    const { knowledgebasesBookmarks, knowledgebasesSize } = get();

    const knowledgebases = knowledgebasesBookmarks?.data.slice(0, knowledgebasesSize);
    if (knowledgebases?.length === 0) return set({ knowledgebasesBookmarks: null, knowledgebases: [] });

    set({
      knowledgebases: knowledgebases?.map((knowledgebase) => knowledgebase.attributes?.metadata as KnowledgeBase),
      showKnowledgeBasesMoreButton: (knowledgebasesBookmarks?.meta?.pagination.total || 0) > knowledgebasesSize,
    });
  },
  fetchAndSetCourses: async () => {
    const { coursesBookmarks, coursesSize } = get();

    const courses = coursesBookmarks?.data.slice(0, coursesSize);
    if (courses?.length === 0) return set({ coursesBookmarks: null, courses: [] });

    set({
      courses: courses?.map((course) => course.attributes?.metadata as Course),
      showCoursesMoreButton: (coursesBookmarks?.meta?.pagination.total || 0) > coursesSize,
    });
  },

  handleMore: async (type: GENERATED.Enum_Bookmark_Category) => {
    const size = get().knowledgebasesSize + SIZE;
    await get().fetchBookmarks(type, size);
  },
}));
